import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate } from "react-router-dom";
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import toast from "react-hot-toast";
import { Helpers } from "../../../helpers/Helpers";
import DeclarationInformation from "./Components/DeclarationInformation";
import ProductInformation from "./Components/ProductInformation";
import GeneralInformation from "./Components/GeneralInformation";
import ServicesInformation from "./Components/ServicesInformation";
import { GetAgreementByIdResponse, GetAgreementByIdResponseAgreementDetail } from "../../../models/response/agreement/GetAgreementByIdResponse";
import { AgreementService } from "../../../services/AgreementService";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import { ServiceService } from "../../../services/ServiceService";
import { GetServiceByIdResponse } from "../../../models/response/service/GetServiceByIdResponse";
import { RootState } from "../../../redux/store";
import moment from "moment";
import ResultInformation from "./Components/ResultInformation";
import { PriceService } from "../../../services/PriceService";
import { GetPriceByIdResponse, GetPriceByIdResponseData } from "../../../models/response/price/GetPriceByIdResponse";
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect";
import { InvoiceService } from "../../../services/InvoiceService";
import { AddInvoiceRequest, AddInvoiceRequestInvoiceDetail } from "../../../models/request/invoice/AddInvoiceRequest";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../services/ConstantService";
import { CompanyService } from "../../../services/CompanyService";
import { GetCompanyByIdResponse } from "../../../models/response/company/GetCompanyByIdResponse";
import { CurrencyConversionService } from "../../../services/CurrencyConversionService";
import { GetCurrencyConversionListResponse } from "../../../models/response/currencyConversion/GetCurrencyConversionListResponse";
import { GetServiceListResponse } from "../../../models/response/service/GetServiceListResponse";
import { AddInvoiceResponse } from "../../../models/response/invoice/AddInvoiceResponse";
import { AddAntrepoVehicleInvoiceResponse } from "../../../models/response/invoice/AddAntrepoVehicleInvoiceResponse";

export interface InOutListModelDetailModel {
    entityId: string
    ledgerNo: string
    antrepoDeclarationNo: string
    parentId: string
    productKindName: string
    productKindId: string
    potTypeName: string
    potTypeId: string
    isSelected: boolean
    stockPotQuantity: string
    stockGrossWeight: string
    stockVolume: string
    stockArea: string
    processPotQuantity: string
    processGrossWeight: string
    processVolume: string
    processArea: string
    startDate: string | undefined
    endDate: string | undefined
    palletCount: string
    containerCount: string
    vehicleCount: string
    gTipId: string
    antrepoInVehicleProductId: string
    antrepoInVehicleId: string | undefined
    antrepoOutVehicleId: string | undefined
}

export interface InOutListModelServiceModel {
    entityId: string
    ledgerNo: string
    parentId: string
    serviceName: string
    serviceId: string
    multiplierId: string
    quantity: string
    needQuantity: boolean
    multiplierName: string
    isSelected: boolean
    antrepoDeclarationNo: string
    antrepoInVehicleServiceId: string | undefined
    antrepoOutVehicleServiceId: string | undefined
}

export interface InOutListModel {
    ledgerNo: string
    antrepoDeclarationNo: string
    antrepoDeclarationDateStr: string
    isSelected: boolean
    parentId: string | undefined
    entityId: string
    details: InOutListModelDetailModel[]
    services: InOutListModelServiceModel[]
}

export interface ResponseModel {
    ledgerNo: string
    antrepoDeclarationNo: string
    productKindName: string
    serviceName: string
    serviceId: string
    unitPrice: string
    quantity: string
    formula: string
    total: string
    localTotal: string
    currencyTypeName: string
    agreementIndex: number
    productIndex: number
    agreementName: string | undefined
    antrepoInVehicleId: string | undefined
    antrepoOutVehicleId: string | undefined
    antrepoInVehicleServiceId: string | undefined,
    antrepoOutVehicleServiceId: string | undefined
}

const CalculateList = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Ön Muhasebe > Hesaplama"
    const dispatch = useDispatch();

    const [selectedCurrentCompany, setSelectedCurrentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isOut, setIsOut] = useState(false);
    const [isIn, setIsIn] = useState(true);
    const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'));
    const [inOutList, setInOutList] = useState<InOutListModel[]>([]);
    const [inOutDetailList, setInOutDetailList] = useState<InOutListModelDetailModel[]>([]);
    const [inOutServiceList, setInOutServiceList] = useState<InOutListModelServiceModel[]>([]);
    const [selectedAgreements, setSelectedAgreements] = useState<CustomMultiSelectModel[]>([]);
    const [responseList, setResponseList] = useState<ResponseModel[]>([]);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [agreementList, setAgreementList] = useState<CustomSingleSelectModel[]>([]);
    const [currencyTypes, setCurrencyTypes] = useState<CustomSingleSelectModel[]>([]);

    useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        // try {
        //     dispatch(storeActivityIndicator(true));

        //     var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

        //     if (id) {
        //         var response: GetCaseMovementByIdResponse = await CaseMovementService.getCaseMovementById(id);

        //         if (!response.isSuccess) {
        //             toast.error(response.message)
        //             return;
        //         }

        //         setCaseMovementId(response.data.caseMovementId);
        //         setRefNo(response.data.refNo);

        //         if (response.data.caseMovementTypeId)
        //             setSelectedCaseMovementType({ label: response.data.caseMovementTypeName, value: response.data.caseMovementTypeId, additionalValue1: response.data.caseMovementTypeKey })

        //         if (response.data.caseId)
        //             setSelectedCase({ label: response.data.caseName, value: response.data.caseId });

        //         setPrice(response.data.price.toFixed(2));

        //         if (response.data.currentCompanyId)
        //             setSelectedCurrentCompany({ label: response.data.currentCompanyName, value: response.data.currentCompanyId });

        //         setDesc(response.data.description);

        //         setProcessDate(response.data.processDate);
        //         setIsCustomActive(response.data.isCustomActive);
        //     }
        // } catch (error: any) {
        //     toast.error(error)
        // }
        // finally {
        //     dispatch(storeActivityIndicator(false))
        // }
    }

    const onAgreementChange = async (selectedValues: CustomMultiSelectModel[]) => {
        try {
            if (selectedValues.length == 0) {
                setSelectedAgreements([]);
                return;
            }

            dispatch(storeActivityIndicator(true))

            setSelectedAgreements(selectedValues);

            var currencyTypeList: CustomSingleSelectModel[] = [];

            for (var i = 0; i < selectedValues.length; i++) {
                var obj: CustomSingleSelectModel | undefined = undefined;

                if (selectedValues[i].additionalValue1?.includes('FYL')) {
                    var response2: GetPriceByIdResponse = await PriceService.getPriceById(selectedValues[i].value);

                    if (!response2.isSuccess) {
                        toast.error(response2.message)
                        return;
                    }

                    obj = {
                        label: response2.data.currencyTypeName + '',
                        value: response2.data.currencyTypeId
                    }

                    if (!currencyTypeList.find(x => x.label == obj?.label)) {
                        currencyTypeList.push(obj)
                    }
                }
                else {
                    var response: GetAgreementByIdResponse = await AgreementService.getAgreementById(selectedValues[i].value);

                    if (!response.isSuccess) {
                        toast.error(response.message)
                        return;
                    }

                    var currencyTypeIds = [...new Set(response.data.agreementDetails.map(x => x.currencyTypeId + ''))];

                    for (var i = 0; i < currencyTypeIds.length; i++) {
                        obj = {
                            label: response.data.agreementDetails.find(x => x.currencyTypeId == currencyTypeIds[i])?.currencyTypeName + '',
                            value: currencyTypeIds[i]
                        }

                        if (!currencyTypeList.find(x => x.label == obj?.label)) {
                            currencyTypeList.push(obj)
                        }
                    }
                }
            }

            setCurrencyTypes(currencyTypeList);

            if (currencyTypeList.length == 1) {
                setSelectedCurrencyType(currencyTypeList[0])
            }
            else {
                setSelectedCurrencyType(undefined)
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const getMultipliers = (agreementDetail: GetAgreementByIdResponseAgreementDetail | GetPriceByIdResponseData, product: InOutListModelDetailModel) => {
        var multiplier1 = 1;
        var multiplier2 = 1;

        ["multiplier1", "multiplier2"].forEach((item) => {
            // Gün
            if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "1") {
                var day = 0;
                if ((isIn ? selectedDate : product.endDate)?.split('T')[0].split(' ')[0] != product.startDate?.split('T')[0].split(' ')[0])
                    day = Math.ceil(moment.duration(moment((isIn ? selectedDate : product.endDate)?.split('T')[0].split(' ')[0]).diff(moment(product.startDate?.split('T')[0].split(' ')[0]))).asDays()) + 1;

                if (item == "multiplier1")
                    multiplier1 = day;
                else if (item == "multiplier2")
                    multiplier2 = day;
            }
            // Ton
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "2") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.processGrossWeight) / 1000;
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.processGrossWeight) / 1000;
            }
            // Adet
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "3") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.processPotQuantity);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.processPotQuantity);
            }
            // Fix
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "4") {

            }
            // Palet Adet
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "5") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.palletCount);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.palletCount);
            }
            // Konteyner Adet
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "6") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.containerCount);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.containerCount);
            }
            // Kg
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "7") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.processGrossWeight);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.processGrossWeight);
            }
            // M2
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "9") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.processArea);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.processArea);
            }
            // M3
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "10") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.processVolume);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.processVolume);
            }
            // Araç Adet
            else if ((item == "multiplier1" ? agreementDetail.multiplier1Key : agreementDetail.multiplier2Key) == "12") {
                if (item == "multiplier1")
                    multiplier1 = Helpers.toNumber(product.vehicleCount);
                else if (item == "multiplier2")
                    multiplier2 = Helpers.toNumber(product.vehicleCount);
            }
            // }
        })

        return { multiplier1, multiplier2 };
    }

    function buildExchangeRates() {
        var tryBasedRates: any = {};

        auth.currencyConversionList.forEach(({ fromCurrencyName, toCurrencyName, sell }) => {
            if (fromCurrencyName === "TRY") {
                tryBasedRates[toCurrencyName] = 1 / sell;
            }
            // İstersen ters durumları da kontrol edebilirsin
        });

        var rates: any = { "TRY": {} };

        // TRY'den diğerlerine doğrudan oran
        for (const [currency, rate] of Object.entries(tryBasedRates)) {
            var _rate: any = rate;
            rates["TRY"][currency] = rate;

            // Diğerlerinden TRY'ye ters oran
            if (!rates[currency]) rates[currency] = {};
            rates[currency]["TRY"] = 1 / _rate;
        }

        // Diğerlerinden diğerlerine çapraz kur (örneğin USD → EUR)
        const currencies = Object.keys(tryBasedRates);
        for (let i = 0; i < currencies.length; i++) {
            for (let j = 0; j < currencies.length; j++) {
                if (i === j) continue;

                const from = currencies[i];
                const to = currencies[j];

                const rateFromTRY = 1 / tryBasedRates[from]; // X TRY / 1 from
                const rateToTRY = tryBasedRates[to];         // 1 TRY → to

                rates[from][to] = rateFromTRY * rateToTRY;   // from → to
            }
        }

        return rates;
    }

    function convertCurrency(amount: number, baseCurrency: string, targetCurrency: string) {
        if (baseCurrency == targetCurrency)
            return amount;

        var rates = buildExchangeRates();

        if (rates[baseCurrency] && rates[baseCurrency][targetCurrency]) {
            return amount * rates[baseCurrency][targetCurrency];
        } else if (rates[targetCurrency] && rates[targetCurrency][baseCurrency]) {
            return amount / rates[targetCurrency][baseCurrency];
        } else {
            throw new Error(`Kur bilgisi bulunamadı: ${baseCurrency} -> ${targetCurrency}`);
        }
    }

    const calculatePrice = async () => {
        try {
            if (!selectedCurrentCompany)
                toast.error('Firma alanını doldurunuz!')
            else if (isIn && Helpers.isEmpty(selectedDate))
                toast.error('Antrepo Çıkış Tarihi alanını doldurunuz!')
            else if (selectedAgreements.length == 0)
                toast.error('Anlaşma Adı alanını doldurunuz!')
            else if (!selectedCurrencyType)
                toast.error('Para Birimi alanını doldurunuz!')
            else {
                if (isIn) {
                    for (var i = 0; i < inOutDetailList.length; i++) {
                        var item = inOutDetailList[i];

                        if (Helpers.toNumber(item.processPotQuantity) > Helpers.toNumber(item.stockPotQuantity)) {
                            toast.error("Çıkan Kap, Stok Kap'tan fazla olamaz!")
                            return;
                        }

                        if (Helpers.toNumber(item.processVolume) > Helpers.toNumber(item.stockVolume)) {
                            toast.error("Çıkan M3, Stok M3'ten fazla olamaz!")
                            return;
                        }

                        if (Helpers.toNumber(item.processArea) > Helpers.toNumber(item.stockArea)) {
                            toast.error("Çıkan M2, Stok M2'den fazla olamaz!")
                            return;
                        }

                        if (Helpers.toNumber(item.processGrossWeight) > Helpers.toNumber(item.stockGrossWeight)) {
                            toast.error("Çıkan Brüt Ağırlık, Stok Brüt Ağırlık'tan fazla olamaz!")
                            return;
                        }
                    }
                }

                var responseList: ResponseModel[] = []

                dispatch(storeActivityIndicator(true));

                for (var c = 0; c < selectedAgreements.length; c++) {
                    var agreement = selectedAgreements[c];

                    if (agreement.additionalValue1?.includes('FYL')) {
                        var response3: GetPriceByIdResponse = await PriceService.getPriceById(agreement.value);

                        if (!response3.isSuccess) {
                            toast.error(response3.message)
                            return;
                        }


                        inOutDetailList.forEach((product, productIndex) => {
                            // if (product.potTypeId == agreementDetail.potTypeId) {
                            const { multiplier1, multiplier2 } = getMultipliers(response3.data, product);

                            var total = multiplier1 * multiplier2 * Helpers.toNumber(response3.data.unitPrice);

                            var fromCurrency = response3.data.currencyTypeName;
                            var toCurrency = selectedCurrencyType.label;

                            if (fromCurrency != toCurrency) {
                                total = convertCurrency(total, fromCurrency, toCurrency);
                            }

                            var o: ResponseModel = {
                                antrepoDeclarationNo: product.antrepoDeclarationNo,
                                // formula: [multiplier1, multiplier2, agreementDetail.unitPrice,]
                                formula: [multiplier1, multiplier2, Helpers.toNumber(response3.data.unitPrice)].join(' x '),
                                ledgerNo: product.ledgerNo,
                                localTotal: convertCurrency(total, toCurrency, "TRY").toFixed(2),
                                productKindName: product.productKindName,
                                quantity: (multiplier1 * multiplier2).toFixed(2),
                                serviceName: response3.data.serviceName,
                                total: total.toFixed(2),
                                unitPrice: response3.data.unitPrice + '',
                                currencyTypeName: selectedCurrencyType.label,
                                agreementIndex: i,
                                productIndex: productIndex,
                                agreementName: agreement.additionalValue1,
                                serviceId: response3.data.serviceId,
                                antrepoInVehicleId: product.antrepoInVehicleId,
                                antrepoOutVehicleId: product.antrepoOutVehicleId,
                                antrepoInVehicleServiceId: undefined,
                                antrepoOutVehicleServiceId: undefined
                            }

                            responseList.push(o);
                            // }
                        })
                    }
                    else {

                        var response: GetAgreementByIdResponse = await AgreementService.getAgreementById(agreement.value);

                        if (!response.isSuccess) {
                            toast.error(response.message)
                            return;
                        }

                        var servicesServices = inOutServiceList.map(x => x.serviceId);

                        for (var i = 0; i < response.data.agreementDetails.length; i++) {
                            var agreementDetail = response.data.agreementDetails[i];

                            if (servicesServices.includes(agreementDetail.serviceId))
                                continue;

                            // if (agreementDetail.currencyTypeId != selectedCurrencyType.value)
                            //     continue;

                            var response2: GetServiceByIdResponse = await ServiceService.getServiceById(agreementDetail.serviceId);

                            if (!response2.isSuccess) {
                                toast.error(response2.message)
                                return;
                            }

                            if (response2.data.serviceIncomeTypes.map(x => x.additionalValue1).includes("1"))
                                continue;

                            inOutDetailList.forEach((product, productIndex) => {
                                // if (product.potTypeId == agreementDetail.potTypeId) {

                                const { multiplier1, multiplier2 } = getMultipliers(agreementDetail, product);

                                var total = multiplier1 * multiplier2 * Helpers.toNumber(agreementDetail.unitPrice);

                                var fromCurrency = agreementDetail.currencyTypeName;
                                var toCurrency = selectedCurrencyType.label;

                                if (fromCurrency != toCurrency) {
                                    total = convertCurrency(total, fromCurrency, toCurrency);
                                    agreementDetail.unitPrice = convertCurrency(Helpers.toNumber(agreementDetail.unitPrice), fromCurrency, toCurrency).toFixed(2);
                                }

                                var o: ResponseModel = {
                                    antrepoDeclarationNo: product.antrepoDeclarationNo,
                                    // formula: [multiplier1, multiplier2, agreementDetail.unitPrice,]
                                    formula: [multiplier1, multiplier2, Helpers.toNumber(agreementDetail.unitPrice)].join(' x '),
                                    ledgerNo: product.ledgerNo,
                                    localTotal: convertCurrency(total, toCurrency, "TRY").toFixed(2),
                                    productKindName: product.productKindName,
                                    quantity: (multiplier1 * multiplier2).toFixed(2),
                                    serviceName: agreementDetail.serviceName,
                                    total: total.toFixed(2),
                                    unitPrice: agreementDetail.unitPrice + '',
                                    currencyTypeName: selectedCurrencyType.label,
                                    agreementIndex: i,
                                    productIndex: productIndex,
                                    agreementName: agreement.additionalValue1,
                                    serviceId: agreementDetail.serviceId,
                                    antrepoInVehicleId: product.antrepoInVehicleId,
                                    antrepoOutVehicleId: product.antrepoOutVehicleId,
                                    antrepoInVehicleServiceId: undefined,
                                    antrepoOutVehicleServiceId: undefined
                                }

                                responseList.push(o);
                                // }
                            })
                        }

                        responseList = responseList.sort(function (a, b) {
                            if (a.productIndex === b.productIndex) {
                                // Price is only important when cities are the same
                                return b.agreementIndex - a.agreementIndex;
                            }
                            return a.productIndex > b.productIndex ? 1 : -1;
                        });

                        for (var i = 0; i < inOutServiceList.length; i++) {
                            var item2 = inOutServiceList[i];

                            var _agreementDetail = response.data.agreementDetails.find(x => x.serviceId == item2.serviceId && (x.multiplier1Id == item2.multiplierId || x.multiplier2Id == item2.multiplierId));

                            if (_agreementDetail) {

                                // if (_agreementDetail.currencyTypeId != selectedCurrencyType.value)
                                //     continue;

                                var multiplier1Total = 0;
                                var multiplier2Total = 0;

                                var fromCurrency = _agreementDetail.currencyTypeName;
                                var toCurrency = selectedCurrencyType.label;

                                for (var k = 0; k < inOutDetailList.length; k++) {
                                    var product = inOutDetailList[k];
                                    const { multiplier1, multiplier2 } = getMultipliers(_agreementDetail, product);

                                    multiplier1Total += multiplier1;
                                    multiplier2Total += multiplier2;
                                }

                                var total = (item2.needQuantity ? Helpers.toNumber(item2.quantity) : (multiplier1Total * multiplier2Total)) * Helpers.toNumber(_agreementDetail.unitPrice);

                                if (fromCurrency != toCurrency) {
                                    total = convertCurrency(total, fromCurrency, toCurrency);
                                    _agreementDetail.unitPrice = convertCurrency(Helpers.toNumber(_agreementDetail.unitPrice), fromCurrency, toCurrency).toFixed(2);
                                }

                                var o: ResponseModel = {
                                    antrepoDeclarationNo: item2.antrepoDeclarationNo,
                                    // formula: [multiplier1, multiplier2, agreementDetail.unitPrice,]
                                    formula: [(item2.needQuantity ? Helpers.toNumber(item2.quantity) : (multiplier1Total * multiplier2Total)), Helpers.toNumber(_agreementDetail.unitPrice)].join(' x '),
                                    ledgerNo: item2.ledgerNo,
                                    localTotal: convertCurrency(total, toCurrency, "TRY").toFixed(2),
                                    productKindName: 'Ek Hizmet',
                                    quantity: (item2.needQuantity ? Helpers.toNumber(item2.quantity) : (multiplier1Total * multiplier2Total)).toFixed(2),
                                    serviceName: _agreementDetail.serviceName,
                                    total: total.toFixed(2),
                                    unitPrice: _agreementDetail.unitPrice + '',
                                    currencyTypeName: selectedCurrencyType.label,
                                    agreementIndex: 0,
                                    productIndex: 0,
                                    agreementName: agreement.additionalValue1,
                                    serviceId: _agreementDetail.serviceId,
                                    antrepoInVehicleId: undefined,
                                    antrepoOutVehicleId: undefined,
                                    antrepoInVehicleServiceId: item2.antrepoInVehicleServiceId,
                                    antrepoOutVehicleServiceId: item2.antrepoOutVehicleServiceId
                                }

                                responseList.push(o);
                            }
                        }
                    }
                }


                // var newList: ResponseModel[] = [];
                // var noRefList: ResponseModel[] = JSON.parse(JSON.stringify(responseList));

                // for (var i = 0; i < noRefList.length; i++) {
                //     var item = noRefList[i];

                //     var control = newList.find(x =>
                //         x.ledgerNo == item.ledgerNo &&
                //         x.antrepoDeclarationNo == item.antrepoDeclarationNo &&
                //         x.productKindName == item.productKindName &&
                //         x.serviceName == item.serviceName &&
                //         x.unitPrice == item.unitPrice
                //     );

                //     if (control) {
                //         control.quantity = (Helpers.toNumber(control.quantity) + Helpers.toNumber(item.quantity)).toFixed(2);
                //         // control.formula = "";
                //         control.total = (Helpers.toNumber(control.total) + Helpers.toNumber(item.total)).toFixed(2);
                //         control.localTotal = (Helpers.toNumber(control.localTotal) + Helpers.toNumber(item.localTotal)).toFixed(2);
                //         control.multiplier1 = Helpers.toNumber(control.multiplier1?.toString()) + Helpers.toNumber(item.multiplier1?.toString());
                //         control.multiplier2 = Helpers.toNumber(control.multiplier2?.toString()) + Helpers.toNumber(item.multiplier2?.toString());
                //     }
                //     else {
                //         newList.push(item);
                //     }
                // }

                // for (var i = 0; i < newList.length; i++) {
                //     var item = newList[i];

                //     newList[i].formula = [item.multiplier1, item.multiplier2, Helpers.toNumber(item.unitPrice)].filter(x => x && !Helpers.isEmpty(x)).join(' x ')
                // }

                // setResponseList(newList);

                if (responseList.length == 0) {
                    toast.error('Seçilen anlaşma uygun değildir!')
                }

                for (var i = 0; i < responseList.length; i++) {
                    if (Helpers.toNumber(responseList[i].quantity) == 1)
                        responseList[i].formula = responseList[i].formula.replace("1 x 1 x", "1 x");
                }


                setResponseList(responseList.filter(x => Helpers.toNumber(x.quantity) > 0));
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const createSaleInvoice = async () => {
        try {
            if (!selectedCurrentCompany)
                return;

            if (!selectedCurrencyType)
                return;

            dispatch(storeActivityIndicator(true));

            // moduleId
            var response: GetConstantListResponse = await ConstantService.getConstantList('MODULE', undefined, "AN");

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var moduleId = response.data[0].constantId;

            // invoiceCategoryId
            var response: GetConstantListResponse = await ConstantService.getConstantList('SALE_CATEGORY', undefined, "1");

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var invoiceCategoryId = response.data[0].constantId;

            // invoiceStatusId
            var response: GetConstantListResponse = await ConstantService.getConstantList('INVOICE_STATUS', undefined, "1");

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var invoiceStatusId = response.data[0].constantId;

            // currencyRateTypeId
            var response: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY_TYPE', undefined, "1");

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var currencyRateTypeId = response.data[0].constantId;

            // invoiceTypeId
            // Otomatik olusturulan faturada tip Temel Fatura (anahtar 1; 06.10.2026, eskiden Ticari).
            var response: GetConstantListResponse = await ConstantService.getConstantList('INVOICE_TYPE', undefined, "1");

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            var invoiceTypeId = response.data[0].constantId;

            var response2: GetCompanyByIdResponse = await CompanyService.getCompanyById(selectedCurrentCompany.value);

            if (!response2.isSuccess) {
                toast.error(response2.message)
                return;
            }

            var defaultAdress = response2.data.companyAddresses.find(x => x.isDefault)

            if (!defaultAdress) {
                toast.error('Seçilen firmada varsayılan adres bulunamadı.');
                return;
            }

            if (!response2.data.paymentTypeId) {
                toast.error('Seçilen firmada varsayılan ödeme şekli bulunamadı.');
                return;
            }

            if (!response2.data.maturityPeriodId || !response2.data.maturityPeriodKey) {
                toast.error('Seçilen firmada varsayılan ödeme vadesi bulunamadı.');
                return;
            }

            var invoiceDate = isIn ? selectedDate : moment().format('YYYY-MM-DD');

            var paymentDate = moment(invoiceDate, "YYYY-MM-DD").add('days', parseInt(response2.data.maturityPeriodKey)).format('YYYY-MM-DD');

            var response3: GetCurrencyConversionListResponse = await CurrencyConversionService.getCurrencyConversionList(invoiceDate);

            if (!response3.isSuccess) {
                toast.error(response3.message)
                return;
            }


            var currency = response3.data.find(x => x.toCurrencyId == selectedCurrencyType.value);

            var currencyRate = currency?.sellStr;

            if (!currency) {

                if (selectedCurrencyType.label == "TRY") {
                    currencyRate = "1";
                }
                else {
                    toast.error('Seçilen tarihe ait kur bulunamadı.');
                    return;
                }
            }

            var response4: GetServiceListResponse = await ServiceService.getServiceList(true);

            if (!response4.isSuccess) {
                toast.error(response4.message)
                return;
            }

            var obj: AddInvoiceRequest = {
                moduleId: moduleId,
                currentCompanyId: selectedCurrentCompany.value,
                currentCompanyAddressTypeId: defaultAdress.addressTypeId,
                addressText: defaultAdress.addressText,
                operationTypeId: undefined,
                invoiceCategoryId: invoiceCategoryId,
                invoiceStatusId: invoiceStatusId,
                invoiceDate: invoiceDate,
                serialNo: '-',
                paymentTypeId: response2.data.paymentTypeId,
                maturityPeriodId: response2.data.maturityPeriodId,
                paymentDate: paymentDate,
                currencyDate: invoiceDate,
                currencyTypeId: selectedCurrencyType.value,
                currency: currencyRate,
                transferDate: undefined,
                fileArchives: [],
                invoiceId: undefined,
                isSale: 1,
                isPurchase: 0,
                isRefund: 0,
                refNo: undefined,
                currencyRateTypeId: currencyRateTypeId,
                invoiceTypeId: invoiceTypeId,
                description: '-',
                invoiceDetails: responseList.map(function (x) {
                    var taxRate = response4.data.find(a => a.serviceId == x.serviceId)?.incomePercentageName;
                    var taxPrice = ((Helpers.toNumber(x.total) / 100) * Helpers.toNumber(taxRate)).toFixed(2);

                    var obj2: AddInvoiceRequestInvoiceDetail = {
                        description: x.antrepoDeclarationNo + " - " + x.formula,
                        quantity: x.quantity,
                        serviceId: x.serviceId,
                        unitPrice: x.unitPrice,
                        exceptionId: undefined,
                        totalWithoutTaxPrice: x.total,
                        taxRate: taxRate,
                        taxPrice: taxPrice,
                        totalPrice: (Helpers.toNumber(x.total) + Helpers.toNumber(taxPrice)).toFixed(2),
                        withholdingId: undefined,
                        withholdingPrice: undefined
                    };

                    return obj2;
                })
            }

            var response5: AddInvoiceResponse = await InvoiceService.addInvoice(obj);

            if (!response5.isSuccess) {
                toast.error(response5.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            for (var i = 0; i < responseList.length; i++) {
                if (!Helpers.isEmpty(responseList[i].antrepoInVehicleId) || !Helpers.isEmpty(responseList[i].antrepoOutVehicleId) || !Helpers.isEmpty(responseList[i].antrepoInVehicleServiceId) || !Helpers.isEmpty(responseList[i].antrepoOutVehicleServiceId)) {
                    var response6: AddAntrepoVehicleInvoiceResponse = await InvoiceService.addAntrepoVehicleInvoice({
                        antrepoInVehicleId: responseList[i].antrepoInVehicleId,
                        antrepoOutVehicleId: responseList[i].antrepoOutVehicleId,
                        antrepoVehicleInvoiceId: undefined,
                        invoiceId: response5.data.invoiceId,
                        antrepoInVehicleServiceId: responseList[i].antrepoInVehicleServiceId,
                        antrepoOutVehicleServiceId: responseList[i].antrepoOutVehicleServiceId
                    });

                    if (!response6.isSuccess) {
                        toast.error(response6.message);
                        dispatch(storeActivityIndicator(false));
                        return;
                    }
                }
            }

            toast.success(response5.message);

            navigate(window.location.pathname.replace('calculate', 'saleinvoice').replace('list', 'listadd') + '?id=' + response5.data.invoiceId);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <GeneralInformation
                        isOut={isOut}
                        selectedCurrentCompany={selectedCurrentCompany}
                        setInOutDetailList={setInOutDetailList}
                        setInOutList={setInOutList}
                        setIsOut={setIsOut}
                        setSelectedCurrentCompany={setSelectedCurrentCompany}
                        setInOutServiceList={setInOutServiceList}
                        isIn={isIn}
                        setIsIn={setIsIn}
                        setResponseList={setResponseList}
                        setSelectedAgreements={setSelectedAgreements}
                        setSelectedDate={setSelectedDate}
                        setAgreementList={setAgreementList}
                        setCurrencyTypes={setCurrencyTypes}
                        setSelectedCurrencyType={setSelectedCurrencyType}
                        onAgreementChange={onAgreementChange}
                    />

                    {
                        inOutList.length > 0 && (
                            <DeclarationInformation
                                inOutList={inOutList}
                                setInOutList={setInOutList}
                                inOutDetailList={inOutDetailList}
                                setInOutDetailList={setInOutDetailList}
                                inOutServiceList={inOutServiceList}
                                setInOutServiceList={setInOutServiceList}
                                isIn={isIn}
                                isOut={isOut}
                            />
                        )
                    }

                    {
                        inOutDetailList.length > 0 && (
                            <ProductInformation
                                inOutDetailList={inOutDetailList}
                                selectedAgreements={selectedAgreements}
                                selectedDate={selectedDate}
                                setInOutDetailList={setInOutDetailList}
                                setSelectedAgreements={setSelectedAgreements}
                                setSelectedDate={setSelectedDate}
                                isIn={isIn}
                                isOut={isOut}
                                selectedCurrencyType={selectedCurrencyType}
                                setSelectedCurrencyType={setSelectedCurrencyType}
                                agreementList={agreementList}
                                currencyTypes={currencyTypes}
                                onAgreementChange={onAgreementChange}
                            />
                        )
                    }

                    {
                        inOutServiceList.length > 0 && (
                            <ServicesInformation
                                inOutServiceList={inOutServiceList}
                                setInOutServiceList={setInOutServiceList}
                            />
                        )
                    }

                    {
                        responseList.length > 0 && (
                            <ResultInformation
                                responseList={responseList}
                                isIn={isIn}
                                isOut={isOut}
                                selectedCurrencyType={selectedCurrencyType}
                            />
                        )
                    }

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box>
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>
                                        Geri
                                    </button>
                                </Box>

                                <Box ml="15px">
                                    <button className="btn btn-primary btn-sm" onClick={calculatePrice}>Hesapla</button>
                                </Box>

                                {
                                    responseList.length > 0 && (
                                        <Box ml="15px">
                                            <button className="btn btn-primary btn-sm" onClick={createSaleInvoice}>Satış Faturası</button>
                                        </Box>
                                    )
                                }
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default CalculateList;